import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { FunctionComponent } from 'react';

interface LeaveTinderDialogProps {
  open: boolean;
  onCancel: () => void;
  onLeave: () => void;
}

export const LeaveTinderDialog: FunctionComponent<LeaveTinderDialogProps> = ({
  open,
  onCancel,
  onLeave,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby="leave-tinder-dialog-title"
      aria-describedby="leave-tinder-dialog-description"
    >
      <DialogTitle id="leave-tinder-dialog-title">
        {'Se désinscrire de Meetic'}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="leave-tinder-dialog-description">
          {
            'Voulez-vous vous désinscrire de Meetic pour cet événement ? Tous vos likes et vos matches seront supprimés définitivement.'
          }
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Annuler</Button>
        <Button onClick={onLeave} autoFocus color="error" variant="contained">
          {'Me désinscrire'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
